"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.PageWrapper = styled_components_1.default.div `
  min-height: 100%;

  @media (min-width: 768px) {
    position: inherit;
    margin: 0 0 0 ${props => props.theme.sizes.navbar};
    padding: 0 15px;
  }
`;
exports.PageWrapperContent = styled_components_1.default.div `
  padding: 30px 20px 40px;
`;
